import { Button, DatePicker, Form, Select } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import style from '../../Styles/Attendance.module.css';
import { DisplayDateFormat } from '../../constant/constant';
import { useDispatch } from 'react-redux';
import {
  setColumn,
  setFilterMonth,
  setFilterYear,
} from '../../store/reducers/filterState';
import ColumnFilter from './ColumnFilter';
import { LuColumns } from 'react-icons/lu';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
const TmFilter = ({
  filterArray,
  handleFilterChange,
  columnFilter,
  setColumnFilter,
  resetColumn,
  clearDatesOnReset,
}) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const location = useLocation();

  let initialValues = {};
  const [form] = Form.useForm();

  const initialValueSetter = (filterArray) => {
    filterArray?.map((item) => {
      initialValues[item.controlName] = item.defaultValue;
    });

    form.setFieldsValue(initialValues);
  };

  const setFilterLocal = (data) => {
    let getFilterLocal = sessionStorage.getItem('filterState');
    let parsed =
      getFilterLocal == undefined
        ? { month: '', year: '' }
        : JSON.parse(atob(getFilterLocal));
    sessionStorage.setItem(
      'filterState',
      btoa(JSON.stringify({ ...parsed, ...data })),
    );
  };

  // const handleReset = () => {
  //   // form.resetFields();
  //   // navigate(window.location.pathname, { replace: true });
  //   // let newObj = nullRemover() || {};

  //   // if (newObj.hasOwnProperty('month')) {
  //   //   setFilterLocal({ month: '' });
  //   //   dispatch(setFilterMonth(''));
  //   // }
  //   // if (newObj.hasOwnProperty('year')) {
  //   //   setFilterLocal({ year: '' });
  //   //   dispatch(setFilterYear(''));
  //   // }
  //   // handleFilterChange(newObj);
  // };

  const handleReset = () => {
    const currentMonth = new Date().toLocaleString('en-US', {
      month: 'long',
    });

    const currentYear = dayjs().year();

    // 1️⃣ Reset form
    form.resetFields();

    // 2️⃣ Clear URL params
    setSearchParams({});

    // 3️⃣ Clear session storage
    sessionStorage.removeItem('filterState');

    // 4️⃣ Reset redux
    dispatch(setFilterMonth(currentMonth));
    dispatch(setFilterYear(currentYear));
    dispatch(setColumn([]));

    // 5️⃣ Build dynamic clean object
    const clearedFilters = {};

    filterArray.forEach((item) => {
      clearedFilters[item.controlName] = '';
    });
    clearedFilters.search = '';
    console.log(clearedFilters, 'clearedFilters');

    // 6️⃣ Keep only month & year default
    if (!clearDatesOnReset) {
      clearedFilters.month = currentMonth;
      clearedFilters.year = currentYear;
    } else {
      clearedFilters.month = undefined;
      clearedFilters.year = undefined;
    }

    // 7️⃣ Update form
    form.setFieldsValue({
      month: clearDatesOnReset ? undefined : currentMonth,
      year: clearDatesOnReset ? undefined : currentYear,
    });

    // 8️⃣ Update URL (optional)
    if (!clearDatesOnReset) {
      setSearchParams({
        month: currentMonth,
        year: currentYear,
      });
    }

    // 9️⃣ Send to parent
    handleFilterChange(clearedFilters);
  };
  const nullRemover = () => {
    let afterClear = form.getFieldsValue();
    let newObj = {};
    for (let obj in afterClear) {
      newObj[obj] =
        afterClear[obj] !== null && afterClear[obj] !== undefined
          ? afterClear[obj]
          : '';
    }

    return newObj;
  };

  const internalChange = (e, controlName, type) => {
    let newObj = nullRemover() || {};
    console.log(e, controlName, type, 'e, controlName, type');

    if (resetColumn) {
      dispatch(setColumn([]));
    }
    if (!!newObj['month']) {
      setFilterLocal({ month: newObj['month'] });
      dispatch(setFilterMonth(newObj['month']));
    }
    if (!!newObj['year']) {
      setFilterLocal({ year: newObj['year'] });
      dispatch(setFilterYear(newObj['year']));
    }
    handleFilterChange(newObj, type);
  };

  const handleDrawer = () => {
    setVisible(!visible);
  };

  const queryFunction = (value, controlName) => {
    const params = new URLSearchParams(searchParams);

    if (value === null || value === undefined || value === '') {
      params.delete(controlName);
    } else {
      params.set(controlName, value);
    }
    params.set('pageNumber', 1);
    params.set('pageSize', 10);
    setSearchParams(params); // ⬅️ THIS WAS MISSING
  };

  // useEffect(() => {
  //   initialValueSetter(filterArray);
  // }, []);
  const getMatchedValue = (value, options) => {
    if (!options) return value;
    // Try number match
    const num = Number(value);
    const numberOption = options.find((o) => o.value === num);
    if (numberOption) return num;
    // Try string match (case-insensitive)
    const strOption = options.find(
      (o) => String(o.value).toLowerCase() === String(value).toLowerCase(),
    );
    if (strOption) return strOption.value;

    return value; // fallback
  };

  useEffect(() => {
    initialValueSetter(filterArray);

    filterArray.forEach((filtr) => {
      const val = searchParams.get(filtr.controlName);
      const normalized = getMatchedValue(val, filtr.options);

      if (!val) return;
      console.log(filtr, 'filtr');

      // -------- DATE PICKER --------
      if (filtr.input === 'date') {
        const d = dayjs(val);
        if (d.isValid()) {
          form.setFieldValue(filtr.controlName, d);
        }
        return;
      }

      // -------- MULTI-SELECT --------
      if (
        filtr.input === 'select' &&
        filtr.mode === 'multiple' &&
        filtr.controlName !== 'project_search'
      ) {
        const arr = val.split(',');
        form.setFieldValue(filtr.controlName, arr);
        return;
      }
      if (filtr.controlName === 'project_search') {
        const arr = val.split(',').map(Number); // 🔥 important
        form.setFieldValue(filtr.controlName, arr);
        return;
      }
      // -------- YEAR SELECT --------
      if (filtr.controlName === 'year') {
        const yearNum = Number(val);
        form.setFieldValue('year', yearNum);
        return;
      }

      if (
        filtr.controlName === 'userRoleID' ||
        filtr.controlName === 'departmentID' ||
        filtr.controlName === 'designationID' ||
        filtr.controlName === 'department_id' ||
        filtr.controlName === 'designation_id' ||
        filtr.controlName === 'department_name'
      ) {
        const result = Number(normalized);
        form.setFieldValue(filtr.controlName, result);
        return;
      } else if (filtr.controlName === 'dropdown_search') {
        const result = Number(normalized);
        form.setFieldValue('dropdown_search', result);
        return;
      } else if (filtr.controlName === 'departmentsID') {
        const result = Number(normalized);
        form.setFieldValue('departmentsID', result);
        return;
      }

      // -------- SIMPLE SELECT --------
      form.setFieldValue(filtr.controlName, normalized);
    });
  }, []);
  useEffect(() => {
    return () => {
      // Clear filter when leaving page
      dispatch(setFilterMonth(''));
      dispatch(setFilterYear(''));
      sessionStorage.removeItem('filterState');
    };
  }, [location.pathname]);
  return (
    <div className="p-1 mb-2 bg-white border">
      <Form form={form}>
        <Row className="m-0 mb-1 mb-md-0 align-items-center">
          <Col sm="auto">
            <b>Filter</b>
          </Col>

          {filterArray.length > 0 &&
            filterArray.map((filtr, index) => (
              <Fragment key={index + 33}>
                {(filtr.input == 'select' || filtr.input == 'date') && (
                  <Col
                    xs="6"
                    className="px-0 mb-2  my-lg-0 pe-1"
                    lg={filtr.col}
                  >
                    <Form.Item
                      name={filtr.controlName}
                      style={{ marginBottom: 0 }}
                    >
                      {filtr.input === 'select' && (
                        <Select
                          showSearch
                          allowClear={filtr.allowClear}
                          mode={filtr.mode}
                          maxTagCount={filtr.maxTagCount}
                          style={{ width: '100%' }}
                          placeholder={filtr.placeholder}
                          optionFilterProp={filtr.optionFilterProp}
                          // defaultValue={filtr.defaultValue}
                          options={filtr.options}
                          onChange={(e) => {
                            internalChange(e, filtr.controlName, filtr.input);
                            queryFunction(e, filtr.controlName, filtr.input);
                          }}
                        />
                      )}
                      {filtr.input === 'date' && (
                        <DatePicker
                          className={`${style.tmfiterwidthres}`}
                          minDate={filtr.minDate}
                          format={DisplayDateFormat}
                          maxDate={filtr.maxDate}
                          placeholder={filtr.placeholder}
                          // defaultValue={filtr.defaultValue}
                          allowClear={filtr.allowClear}
                          onChange={(e) => {
                            internalChange(e, filtr.controlName, filtr.input);
                            queryFunction(e, filtr.controlName, filtr.input);
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                )}
                {filtr.input == 'button' && (
                  <Col lg={filtr.col} className={`${filtr.className} px-0`}>
                    <Button
                      className={`   ${style.tmfiterwidthres}`}
                      type={filtr.type}
                      //disabled={disableButton()}
                      htmlType={filtr.htmlType}
                      onClick={handleReset}
                    >
                      {/* {filtr.text} */}
                      Clear Filter
                    </Button>
                  </Col>
                )}
              </Fragment>
            ))}
          {columnFilter && columnFilter.length > 0 && (
            <Col className={` px-0 text-end`}>
              <Button
                title="Column Filter"
                className={`   ${style.tmfiterwidthres}`}
                onClick={handleDrawer}
              >
                <LuColumns size={20} />
              </Button>
            </Col>
          )}
        </Row>
      </Form>
      {columnFilter && columnFilter.length > 0 && (
        <ColumnFilter
          onClose={handleDrawer}
          visible={visible}
          columnFilter={columnFilter}
          setColumnFilter={setColumnFilter}
        />
      )}
    </div>
  );
};

export default TmFilter;
